import { render } from "./Dictionary.vue?vue&type=template&id=3bbecbf6&scoped=true"
import script from "./Dictionary.vue?vue&type=script&lang=js"
export * from "./Dictionary.vue?vue&type=script&lang=js"

import "./Dictionary.vue?vue&type=style&index=0&id=3bbecbf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbecbf6"]])

export default __exports__